import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import RegisterComingSoonPage from "../../features/auth/pages/RegisterComingSoonPage";

interface ComingSoonGuardProps {
  children?: React.ReactNode;
}

// Routes allowed while the site is in Coming Soon mode (public legal/policy links from footer)
const ALLOWED_PATHS = new Set([
  "/",
  // "/coming-soon",
  // "/terms-of-service",
  // "/privacy-policy",
  // "/cookie-policy",
  // "/compliance-statement",
  // "/kyc-aml-compliance-policy",
  // "/refund-policy",
  // "/acceptable-use-policy",
  // "/dmca-takedown-policy",
  // "/complaints-policy",
  // "/content-provider-agreement",
]);

const ComingSoonGuard: React.FC<ComingSoonGuardProps> = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname.replace(/\/+$/, "") || "/";

  // Coming Soon component loads directly on the "/" route
  if (currentPath === "/") {
    return <RegisterComingSoonPage />;
  }

  // Any other route (e.g. /login, /register, /coming-soon) redirects to "/"
  if (!ALLOWED_PATHS.has(currentPath) || currentPath === "/coming-soon") {
    return (
      <Redirect
        to={{
          pathname: "/",
          search: location.search,
        }}
      />
    );
  }

  return <>{children}</>;
};

export default ComingSoonGuard;
